import { render } from "./BlockAdder.vue?vue&type=template&id=04831829&scoped=true"
import script from "./BlockAdder.vue?vue&type=script&lang=js"
export * from "./BlockAdder.vue?vue&type=script&lang=js"

import "./BlockAdder.vue?vue&type=style&index=0&id=04831829&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04831829"]])

export default __exports__